import { Capacitor } from '@capacitor/core'

import { ApiClient } from '@/generated/api/ApiClient'
import i18n from '@/i18n'
import { API_BASE_URL } from '@/settings'

import { useAuthStore } from './modules/auth/store'

let client: ApiClient | null = null
export const useApiClient = () => {
  if (!client) {
    const authStore = useAuthStore()
    client = new ApiClient({
      BASE: Capacitor.isNativePlatform() ? API_BASE_URL : '',
      WITH_CREDENTIALS: !Capacitor.isNativePlatform(), // Only for web - native uses localStorage
      HEADERS: async (opts): Promise<Record<string, string>> => {
        if (opts.method === 'POST' && opts.url.indexOf('login/refresh') > -1) {
          return {}
        }
        const headers = { 'Accept-Language': i18n.global.locale.value }
        try {
          const token = await authStore.getAccessToken()
          // getAccessToken() guarantees non-empty string or throws error
          return { ...headers, Authorization: `Bearer ${token}` }
        } catch (error) {
          // Return headers without Authorization on any error
          // The request interceptor in App.vue will handle the logout
          return headers
        }
      },
    })
  }
  return client
}
